import { uniqArray as A } from "@hprofits/utils/arrays";
import { UserIdSchema as h } from "../schemas.js";
import { UserRoleSchema as n, PrivilegeSchema as e } from "./schemas.js";
const t = 3, m = 4, s = 5, a = 9, i = 10, c = 11, _ = (r) => {
  switch (r) {
    case t:
      return n.enum.Publisher;
    case m:
      return n.enum.Advert;
    case s:
      return n.enum.Admin;
    case a:
      return n.enum.AdAdmin;
    case i:
      return n.enum.Exchange;
    case c:
      return n.enum.Manager;
  }
  throw new Error(`Unknown role id: ${r}`);
}, P = (r) => {
  switch (r) {
    case n.enum.Publisher:
      return t;
    case n.enum.Advert:
      return m;
    case n.enum.Admin:
      return s;
    case n.enum.AdAdmin:
      return a;
    case n.enum.Exchange:
      return i;
    case n.enum.Manager:
      return c;
    default: {
      const u = r;
      throw new Error(`Unknown role: ${u}`);
    }
  }
}, R = (r) => A(r.flatMap(l)), l = (r) => {
  switch (r) {
    case n.enum.Admin:
      return [
        e.enum.SuperAdmin,
        e.enum.ReadAdmin,
        e.enum.WriteAdmin,
        e.enum.ReadAdvert,
        e.enum.WriteAdvert,
        e.enum.ReadPublisher,
        e.enum.WritePublisher,
        e.enum.ReadExchange,
        e.enum.WriteExchange,
        e.enum.SplitTrafficSourceBySsp
      ];
    case n.enum.Manager:
    case n.enum.AdAdmin:
      return [
        e.enum.ReadAdmin,
        e.enum.WriteAdmin,
        e.enum.ReadAdvert,
        e.enum.WriteAdvert,
        e.enum.ReadPublisher,
        e.enum.WritePublisher,
        e.enum.ReadExchange,
        e.enum.WriteExchange,
        e.enum.SplitTrafficSourceBySsp
      ];
    case n.enum.Advert:
      return [e.enum.ReadAdvert, e.enum.WriteAdvert];
    case n.enum.Publisher:
      return [e.enum.ReadPublisher, e.enum.WritePublisher];
    case n.enum.Exchange:
      return [e.enum.ReadExchange, e.enum.WriteExchange];
    default: {
      const u = r;
      throw new Error(`Unknown role: ${u}`);
    }
  }
}, p = (r, u, o, d) => ({
  id: h.parse(r.userId),
  username: u,
  title: o,
  privileges: R(r.roles),
  refreshToken: d
});
export {
  p as jwtToAuthUser,
  l as mapPrivilegesForRole,
  R as mapPrivilegesForRoles,
  _ as resolveRoleById,
  P as resolveRoleId
};
//# sourceMappingURL=utils.js.map
